<template>
    <div>
        <div class="d-flex justify-space-between">
            <div class="text-h5">Summary Serial Digital</div>
        </div>
        <v-row>
            <v-col cols="12" md="6" class="py-0">
                <v-card class="mt-3 mb-3" outlined>
                    <v-card-title class="d-block justify-space-between">
                        <span class="font-size-18">
                            Total Serial Digital Dibeli di Warehouse
                            <span class="d-block font-size-12">Sales Order dan Penjualan Langsung</span>
                        </span>
                        <div class="d-flex align-center">
                            <v-icon large class="mr-2" color="deep-purple darken-1">mdi-credit-card</v-icon>
                            <span class="font-size-18">{{ summaryDigital.serial_digital_bought | toNumber }} BV</span>
                        </div>
                    </v-card-title>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6" class="py-0">
                <v-card class="mt-3 mb-3" style="height: calc(100% - 23px);" outlined>
                    <v-card-title class="d-block justify-space-between">
                        <span class="font-size-18">
                            Total Sudah Dijual di POS
                        </span>
                        <div class="d-flex align-center">
                            <v-icon large class="mr-2" color="deep-purple darken-1">mdi-cash-multiple</v-icon>
                            <span class="font-size-18">{{ summaryDigital.serial_digital_pos_sold | toNumber }} BV</span>
                        </div>
                    </v-card-title>
                </v-card>
            </v-col>
            <v-col cols="12" md="6" class="py-0">
                <v-card class="mt-3 mb-3" outlined>
                    <v-card-title class="d-block justify-space-between">
                        <span class="font-size-18">
                            Total Belum Dijual di POS
                            <span class="d-block d-md-inline font-size-12">Expired</span>
                        </span>
                        <div class="d-flex align-center">
                            <div class="d-flex flex-column">
                                <div class="d-flex">
                                    <v-icon large class="mr-2" color="deep-purple darken-1">mdi-credit-card-clock</v-icon>
                                    <span class="font-size-18">{{ summaryDigital.serial_digital_pos_expired | toNumber }} BV</span>
                                </div>
                                <span class="font-size-12 ml-2">Terakhir expired: {{ summaryDigital.serial_digital_pos_expired_date | haritanggal }} ( {{ summaryDigital.serial_digital_pos_bv_expired_date | toNumber }} ) BV</span>
                            </div>
                        </div>
                    </v-card-title>
                </v-card>
            </v-col>
            <v-col cols="12" md="6" class="py-0">
                <v-card class="mt-3 mb-3" outlined>
                    <v-card-title class="d-block justify-space-between">
                        <span class="font-size-18">
                            Total Belum Dijual di POS
                            <span class="d-block d-md-inline font-size-12">Belum Expired</span>
                        </span>
                        <div class="d-flex align-center">
                            <v-icon large class="mr-2" color="deep-purple darken-1">mdi-credit-card</v-icon>
                            <span class="d-block font-size-18">{{ summaryDigital.serial_digital_pos_available | toNumber }} BV</span>
                        </div>
                    </v-card-title>
                </v-card>
            </v-col>
        </v-row>
        <v-row>

            <v-col cols="12" md="6" class="py-0">
                <v-card class="mt-3 mb-3" outlined>
                    <v-card-title class="d-block justify-space-between">
                        <span class="font-size-18">
                            Total Belum Dipakai di VO
                            <span class="d-block d-md-inline font-size-12">Belum Expired</span>
                        </span>
                        <div class="d-flex align-center">
                            <v-icon large class="mr-2" color="deep-purple darken-1">mdi-briefcase</v-icon>
                            <span class="font-size-18">{{ summaryDigital.serial_digital_vo_available | toNumber }} BV</span>
                        </div>
                    </v-card-title>
                </v-card>
            </v-col>
            <v-col cols="12" md="6" class="py-0">
                <v-card class="mt-3 mb-3" outlined>
                    <v-card-title class="d-block justify-space-between">
                        <span class="font-size-18">
                            Total Belum Dipakai di VO
                            <span class="d-block d-md-inline font-size-12">Expired</span>
                        </span>
                        <div class="d-flex align-center">
                            <v-icon large class="mr-2" color="deep-purple darken-1">mdi-briefcase-clock</v-icon>
                            <span class="font-size-18">{{ summaryDigital.serial_digital_vo_expired | toNumber }} BV</span>
                        </div>
                    </v-card-title>
                </v-card>
            </v-col>
            <v-col cols="12" md="6" class="py-0">
                <v-card class="mt-3 mb-3" outlined>
                    <v-card-title class="d-block justify-space-between">
                        <span class="font-size-18">
                            Total Dipakai di VO Untuk
                            <span class="d-block d-md-inline">Clone / Registrasi</span>
                        </span>
                        <div class="d-flex align-center">
                            <v-icon large class="mr-2" color="deep-purple darken-1">mdi-account-multiple</v-icon>
                            <span class="font-size-18">{{ summaryDigital.serial_digital_vo_register | toNumber }} BV</span>
                        </div>
                    </v-card-title>
                </v-card>
            </v-col>
            <v-col cols="12" md="6" class="py-0">
                <v-card class="mt-3 mb-3" outlined>
                    <v-card-title class="d-block justify-space-between">
                        <span class="font-size-18">
                            Total Dipakai di VO Untuk <span class="d-block d-md-inline">RO</span>
                        </span>
                        <div class="d-flex align-center">
                            <v-icon large class="mr-2" color="deep-purple darken-1">mdi-refresh</v-icon>
                            <span class="font-size-18">{{ summaryDigital.serial_digital_vo_ro | toNumber }} BV</span>
                        </div>
                    </v-card-title>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'

export default {
    inject: ['theme'],
    components: {},
    data() {
        return {}
    },
    props: {
    },
    computed: {
        ...mapState('auth', ['userData']),
        ...mapState('report', ['summaryDigital', 'konfirmResponse']),
    },
    methods: {
        ...mapActions('report', ['getReportSummarySerialDigital']),
        ...mapMutations(['setOverlay']),

        getData() {
            this.getReportSummarySerialDigital()
        },
    },
    async created() {
        await this.$store.dispatch('setPageTitle', `Summary Serial Digital`)

        await this.getData()
    },
    beforeDestroy() {
        this.clearDataVoucher()
    },
}
</script>

<style>
tbody tr:nth-of-type(even) {
    background-color: rgba(0, 0, 0, .05);
}

.v-avatar .avatar {
    object-position: center;
    object-fit: cover;
}
</style>